export default [
  {
    route: 'Mural',
    title: 'dashboard',
    icon: 'HomeIcon',
    i18n: 'Mural',
    rule: 'dashboard'
  }
]
